/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});
// Get the value of "some_key" in eg "https://example.com/?some_key=some_value"


// product variant functionality

$('.ProductForm__Category a').click(function() {
   $(this).addClass('active_tab').siblings().removeClass('active_tab');
   $('.ProductForm__Option .HorizontalList__Item').css('display','none');
   var targetId = $(this).attr('data-category');  
   $('.ProductForm__Option .HorizontalList__Item[data-category="' + targetId + '"]').css("display",'inline-block');
   $('.sold_out_item').each(function(){
    if ($(this).css('display') == 'inline-block'){
      $('.custom_sold_out').css('display','inline-block');  
    }
  })
})

$('.my_all').click(function(){
  $('.ProductForm__Option  li.HorizontalList__Item').css('display','inline-block')
  $('.custom_sold_out').css('display','inline-block')
})

$('.HorizontalList__Item').click(function(){
  var targetId = $(this).find('label.ColorSwatch').attr('date-image-id');
  $('.my_small_nav[myid="' + targetId + '"] img').trigger("click");
})

$(document).on('variant:changed', function(event) {
  
  $('.iwish-app-block-wrapper').show();
  $('.mf_button').show();
  $('#mf_container').show();
  var vl = $('.ColorSwatch__Radio:checked');  
  for (var i=0; i<vl.length; i++){
    var pr = $(vl[i]).parent()
    if ($(pr).hasClass('sold_out_item')) {
      $('.ProductForm__AddToCart span').html('PRE-ORDER')
      $('.ProductForm__AddToCart').css('border-color','#c41949')
    }
    else {
      $('.ProductForm__AddToCart span').html('ADD TO CART');
      $('.ProductForm__AddToCart').css('border-color','')
      
    }
  }
  $('.ProductForm__AddToCart').removeAttr("disabled");
  $('.iwish-app-block-wrapper').show();
  $('.mf_button').show();
  $('#mf_container').show();
  $('.mf_button').show();
  
  
  var vv = $('.ProductForm__Item .ProductForm__OptionName span').html();
  $('.ProductForm__Option  li.HorizontalList__Item .ColorSwatch[data-tooltip="' + vv + '"]').trigger("click");
})
// end

var page_url = window.location.href;
let qString = params.variant;
if ($('#pButton').hasClass('defaultVariant')) {
  console.log('has class');
} else {
  console.log('doesnt have class');
}
if((page_url.indexOf('?') == -1 || typeof qString != 'string') && !$('#pButtons').hasClass('defaultVariant')){
  var refreshIntervalId = setInterval(function(){
  if ($('.mf_button').length>0){
    $('.mf_button').hide();
    console.log('found make offer button');
    $('#mf_container').css("display", "none");
    clearInterval(refreshIntervalId);
  }
 
},100);
   
  $('input[type="radio"].ColorSwatch__Radio').each(function () {
    $(this).removeAttr('checked');
  });	
  console.log("i should  be here.")
  $('.ProductForm__SelectedValue').html('Choose a Color');
  $('.ProductForm__AddToCart span').html('Choose a Color');
  $('.ProductForm__AddToCart').attr("disabled", true);
  $('.iwish-app-block-wrapper').hide();
  $('.mf_button').hide();
  $('#mf_container').css("display", "none");
} else {
  
  var vl = $('.ColorSwatch__Radio:checked');  
   for (var i=0; i<vl.length; i++){
    var pr = $(vl[i]).parent()
    if ($(pr).hasClass('sold_out_item')) {
      $('.ProductForm__AddToCart span').html('PRE-ORDER')
      $('.ProductForm__AddToCart').css('border-color','#c41949')
    }
    else {
      $('.ProductForm__AddToCart span').html('ADD TO CART');
      $('.ProductForm__AddToCart').css('border-color','')
      
    }
  }
}

$(document).on('variant:changed', function(event) {
  var variant = event.detail.variant;
  $('[data-image-id="1' + variant.id + '"]').last().trigger('click');
  var description = $('label[data-variant-id="' + variant.id + '"]').attr("data-variant-color-description");
  if (description) $('#activeAlt').text(variant.title + " | " + description);
  else $('#activeAlt').text(variant.title);
  setTimeout(function(){
    $("button.gPreorderBtn").removeAttr("style");
   }, 500);
});

var active_el = null;
function show_products(e, el) {
  e.preventDefault();
  if (el.nextElementSibling) {
    for (let i = 0 ; i < $(".facebook-collection").length; i++) {
      let elem = $(".facebook-collection")[i];
      elem.setAttribute("style", "display:none !important;");
    }
    el.nextElementSibling.style.display = "inline-block";
    active_el = el.nextElementSibling;
    $("#section_title").css('display', 'none');
    $("#back_to_main").css('display', 'block');
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const resizeEvent = new Event('resize');
    window.dispatchEvent(resizeEvent);
  }
}

$("#back_to_main").click(function() {
  document.location.reload();
});

/* ── Wishlist Visibility Fix ──
   Shows iWish "Add to Wishlist" button when a variant is selected
   and the Add to Cart button is enabled. */
(function(){
  function checkWishlist(){
    var btn = document.querySelector('.ProductForm__AddToCart');
    var wishBtn = document.querySelector('.iwish-hidden-until-variant');
    if(!btn || !wishBtn) return;
    if(btn.hasAttribute('data-action') && !btn.disabled){
      wishBtn.style.setProperty('display', 'block', 'important');
    } else {
      wishBtn.style.setProperty('display', 'none', 'important');
    }
  }
  function init(){
    var btn = document.querySelector('.ProductForm__AddToCart');
    if(!btn){ setTimeout(init, 500); return; }
    checkWishlist();
    var observer = new MutationObserver(checkWishlist);
    observer.observe(btn, {attributes: true, childList: true});
    document.addEventListener('variant:changed', checkWishlist);
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
